export const nullifyEmptyStringValues = (obj) => {
    let values = { ...obj };
    Object.keys(values).forEach(key => {
        const keyWithType = key;
        const value = values[keyWithType];
        values = { ...values, [keyWithType]: value === "" ? null : value };
    });
    return values;
};
//# sourceMappingURL=nullifyEmptyStringValues.js.map